module.exports = __webpack_public_path__ + "static/media/stomach.94853934.svg";